import axios from 'axios';
import { getApiUrl, getBackendUrl } from '@/common/utils/api';


axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth-token');
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
}, (err) => {
  Promise.reject(err);
});

axios.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401) {
    document.location.href = getBackendUrl('/auth/logout/');
  }
  return Promise.reject(error);
});


export default {
  delete: async (path, data) => {
    try {
      return await axios.delete(
        getApiUrl(path), {
          data,
        },
      );
    } catch (e) {
      return e.response;
    }
  },
  get: async (path, queryParams) => {
    try {
      return await axios.get(
        getApiUrl(path, queryParams),
      );
    } catch (e) {
      return e.response;
    }
  },
  patch: async (path, data, headers) => {
    try {
      return await axios.patch(
        getApiUrl(path),
        data || {},
        headers || {},
      );
    } catch (e) {
      return e.response;
    }
  },
  post: async (path, data, queryParams, headers) => {
    try {
      return await axios.post(
        getApiUrl(path, queryParams),
        data || {},
        headers || {},
      );
    } catch (e) {
      return e.response;
    }
  },
  put: async (path, data, headers) => {
    try {
      return await axios.put(
        getApiUrl(path),
        data || {},
        headers || {},
      );
    } catch (e) {
      return e.response;
    }
  },
};
